import { Component, EventEmitter, Input, Output } from '@angular/core';
import { todayISO } from 'src/app/utils/date-utils';
import { getMancoTypeLabel, MancoOrderResponse, MancoType } from '../manco-order-request';

@Component({
  selector: 'app-manco-order-summary',
  templateUrl: './manco-order-summary.component.html',
  styleUrl: './manco-order-summary.component.scss',
})
export class MancoOrderSummaryComponent {
  @Input() response!: MancoOrderResponse;

  @Output() closeSummaryEmitter = new EventEmitter<void>();

  /**
   * Same rule as the Freshdesk note: a date of today is the plain as-soon-as-possible manco, so showing the row
   * would just repeat the order date. Only a genuinely deferred delivery is worth calling out.
   */
  get hasDeferredDeliveryDate(): boolean {
    const requested = this.response.request?.fixedDeliveryDate;
    return !!requested && requested !== todayISO();
  }

  getMancoTypeLabel(value: MancoType): string {
    return getMancoTypeLabel(value);
  }

  emitClose(): void {
    this.closeSummaryEmitter.emit();
  }
}
